import { startAlerta } from '../../actions/ui/alertas';
import { finishSpinner, startSpinner } from '../../actions/ui/spinner';

export const startFetch =
  (service, responseAction, withLoader = true, validNoContent) =>
  async (dispatch) => {
    if (withLoader) dispatch(startSpinner());
    try {
      const response = await service();
      if (validNoContent && response.status === 204) {
        responseAction(null)
        dispatch(finishSpinner());
      }
      const body = await response.json();
      if (response.ok) {
        responseAction(body);
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      if (withLoader) dispatch(finishSpinner());
      dispatch(
        startAlerta(
          error?.errores?.message || error?.errores?.mensaje || error?.errores,
          'error',
          'Error',
        ),
      );
    }
  };

export const startFetchExcel = (service, title) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await service();
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());
      let url = window.URL.createObjectURL(body);
      let a = document.createElement('a');
      a.href = url;
      a.download = title;
      a.click();
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(
      startAlerta(error?.errores?.message || error?.errores, 'error', 'Error'),
    );
  }
};

export const startFetchPdf = (service) => async (dispatch) => {
  dispatch(startSpinner());
  try {
    const response = await service();
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());
      window.open(URL.createObjectURL(body));
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch(
      startAlerta(error?.errores?.message || error?.errores, 'error', 'Error'),
    );
  }
};
